import { type RegisteredComponent, isEditing } from "@builder.io/sdk-react";

import { RichHeading } from "~/hec/components/organisms/rich-heading/rich-heading";
import { cn } from "~/lib/utils";

import { headingInputs } from "./inputs";
import type { HeadingProps } from "./types";

const Heading: React.FC<HeadingProps> = ({
  tag,
  variant,
  content,
  attributes,
  className,
}) => {
  const { className: attrClassName, ...restAttr } = attributes || {};

  return (
    <RichHeading
      tag={tag}
      variant={variant}
      content={content}
      inEditor={isEditing()}
      className={cn(className, attrClassName)}
      {...restAttr}
      data-testid="heading-HecHeading"
    />
  );
};

export default Heading;

export const HeadingDefinition = {
  component: Heading,
  name: "Heading",
  noWrap: true,
  inputs: headingInputs,
} satisfies RegisteredComponent;
